import FilesModal from "./FilesModal";

export default FilesModal;
